import { colors } from '../../Colors/colors'

export const notes = {
   light: {
      common: {
         titleColor: 'text-gray-900',
         borderColor: 'border-gray-300',
         noteCardTextColor: 'text-gray-500',
         noteCardBorderColor: 'border-gray-300',
         noteCardErrorBorderColor: 'border-error-300',
         noteContentColor: 'text-gray-700',
         defaultBgColor: 'bg-base-white',
         colors: {
            BLUE: 'bg-blue-600',
            BLUE_DARK: 'bg-blue-dark-600',
            BLUE_LIGHT: 'bg-blue-light-600',
            CYAN: 'bg-cyan-600',
            FUCHSIA: 'bg-fuchsia-600',
            GREEN: 'bg-green-600',
            GREEN_LIGHT: 'bg-green-light-600',
            INDIGO: 'bg-indigo-600',
            MOSS: 'bg-moss-600',
            ORANGE: 'bg-orange-600',
            ORANGE_DARK: 'bg-orange-dark-600',
            PINK: 'bg-pink-600',
            PURPLE: 'bg-purple-600',
            ROSE: 'bg-rose-600',
            TEAL: 'bg-teal-600',
            VIOLET: 'bg-violet-600',
            YELLOW: 'bg-yellow-600',
            defaultColor: 'bg-primary-600'
         },
         tooltipBgColor: '!bg-gray-900',
         tooltipTextColor: 'text-base-white',
         expandIconColor: colors['gray-500'],
         collapseIconColor: colors['gray-500'],
         infoIconColor: colors['gray-500'],
         infoTextColor: 'text-gray-600'
      },
      createNote: {
         defaultBorderColor: 'border-gray-300',
         savingTextColor: 'text-gray-700',
         headerTextColor: 'text-gay-800',
         horizontalLineBorderColor: 'border-gray-300',
         notesTextColor: 'text-gray-600',
         refreshIconColor: colors['gray-500'],
         checkIconColor: colors['gray-500'],
         savedNoteColor: 'text-gray-600',
         savingNoteColor: 'text-gray-500',
         retryNoteColor: 'text-error-600'
      },
      notesLog: {
         titleColor: 'text-gray-900',
         dotColor: 'bg-gray-500'
      },
      noteTabs: {
         noteTextColor: 'text-gray-600',
         selectedNoteTextColor: 'text-base-white',
         noteTabsBorderColor: 'border-gray-300',
         tabOverlayColor: 'bg-gray-900',
         backgroundColor: 'bg-black/5',
         disabledNoteTextColor: 'text-gray-500',
         disabledIconColor: colors['gray-500']
      },
      notesAttachmentList: {
         textColor: 'text-gray-700',
         defaultBorderColor: 'border-gray-300'
      }
   },
   dark: {}
}
